import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import communityService from "../../api/communityService";

// Shared free-tier weekly allowance so every CommentsSection instance, the
// composer, and the counters all read the same numbers. Backend is the source
// of truth: we fetch once on mount and overwrite from each create response.
// limit === -1 means unlimited (paid plans / trials).

export const fetchCommunityUsage = createAsyncThunk(
  "communityAllowance/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await communityService.getCommunityUsage();
      return response?.data?.data || null;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error.message);
    }
  },
);

const initialState = {
  // null until first fetch; each is { used, limit, remaining, limit_reached }
  post: null,
  comment: null,
  isLoading: false,
};

const communityAllowanceSlice = createSlice({
  name: "communityAllowance",
  initialState,
  reducers: {
    // Overwrite from a create response's `usage` payload (authoritative).
    setPostUsage: (state, action) => {
      if (action.payload) state.post = action.payload;
    },
    setCommentUsage: (state, action) => {
      if (action.payload) state.comment = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommunityUsage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCommunityUsage.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.post = action.payload.post ?? null;
          state.comment = action.payload.comment ?? null;
        }
      })
      .addCase(fetchCommunityUsage.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setPostUsage, setCommentUsage } = communityAllowanceSlice.actions;
export default communityAllowanceSlice.reducer;
